import { render, staticRenderFns } from "./sportsList.vue?vue&type=template&id=5657f6f0&lang=pug&"
import script from "./sportsList.vue?vue&type=script&lang=js&"
export * from "./sportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports